import NavBar from "../../../components/organisms/navbar";
import { Container, Content, PaymentContainer, Title, Title2, InstructionTitle, InstructionList, InstructionItem, InstructionStep, InstructionItemContent, StyledLink, HighlightedLink } from "../styles";
import { FaWhatsapp } from "react-icons/fa";
import { useParams } from "react-router-dom";
import React from "react";

const PaymentEnrollmentViReiDaPraiaDeJiuJitsuNoGi = () => {
    const { slug, id } = useParams();
    switch (slug) {
        case 'vi-rei-da-praia-de-jiu-jitsu-santarem-pa-nogi':
            return (
                <Container>
                    <NavBar />
                    <Content>
                        <PaymentContainer>
                            <Title>Obrigado por fazer a sua inscrição na</Title>
                            <Title2>
                            {"vi rei da praia no gi 2024".toLocaleUpperCase()}
                            </Title2>
                            <p style={{ color: "red", marginBottom: "0px" }}><b>Inscrição N° {id}</b></p>
                            <InstructionTitle>Instruções:</InstructionTitle>

                            <InstructionList>
                                {/* <InstructionItem color="#f0f4c3"> */}
                                <InstructionItem color="rgb(210, 210, 210)">
                                    <InstructionStep>Passo 1</InstructionStep>
                                    <InstructionItemContent>
                                        Colocar o número da inscrição ( <b style={{ color: "red", marginBottom: "30px" }}>{id}</b> ) na descrição do PIX.
                                    </InstructionItemContent>
                                </InstructionItem>

                                {/* <InstructionItem color="#e3f2fd"> */}
                                <InstructionItem color="rgb(210, 210, 210)">
                                    <InstructionStep>Passo 2</InstructionStep>
                                    <InstructionItemContent>
                                        Efetuar o pagamento através do PIX para:
                                        <ul style={{ listStyle: "none" }}>
                                            <br />
                                            <li>Banco Caixa Econômica</li>
                                            <li>Tipo de Chave PIX CPF</li>
                                            <li><b>Pix: 691.807.841-00 </b></li>
                                            <li>José Carlos Lima Lopes</li>
                                        </ul>
                                    </InstructionItemContent>
                                </InstructionItem>

                                <InstructionItem color="rgb(210, 210, 210)">
                                    {/* <InstructionItem color="#ffecb3"> */}
                                    <InstructionStep>Passo 3</InstructionStep>
                                    <InstructionItemContent>
                                        Enviar o comprovante de pagamento (com número da inscrição na descrição)  para:
                                        <ul style={{ listStyle: "none" }}>
                                            <li>
                                                <br />
                                                <StyledLink
                                                    target="_blank"
                                                    href={`https://whatsa.me/5593991311576/?t=Ol%C3%A1+José+Carlos+Lima%2C+estou+enviando+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2AVI+REI+DA+PRAIA+NO+GI+2024%2A%0A%0A%2AInscri%C3%A7%C3%A3o+N%C2%B0+${id}`}
                                                >
                                                    +55 (93) 99131-1576  <FaWhatsapp />
                                                </StyledLink>
                                            </li>
                                        </ul>
                                    </InstructionItemContent>
                                </InstructionItem>

                                <InstructionItem color="rgb(210, 210, 210)">
                                    {/* <InstructionItem color="#c8e6c9"> */}
                                    <InstructionStep>Passo 4</InstructionStep>
                                    <InstructionItemContent>
                                        Acompanhe o status do pagamento em:
                                        <br />
                                        <ul style={{ listStyle: "none" }}>
                                            <li>
                                                <HighlightedLink href="/profile/subscription">Minhas Inscrições</HighlightedLink>
                                            </li>
                                        </ul>
                                    </InstructionItemContent>
                                </InstructionItem>
                            </InstructionList>
                        </PaymentContainer>
                    </Content>
                </Container>
            )
        case 'tenha-um-slug-nogi':
            return (
                <Container>
                    <NavBar />
                    <Content>
                        <PaymentContainer>
                            <Title>Obrigado por fazer a sua inscrição nO</Title>
                            <Title2>
                                VI REI DA PRAIA NO GI 2024
                            </Title2>
                            <p style={{ color: "red", marginBottom: "0px" }}><b>Inscrição N° {id}</b></p>
                            <InstructionTitle>Instruções:</InstructionTitle>

                            <InstructionList>
                                {/* <InstructionItem color="#f0f4c3"> */}
                                <InstructionItem color="rgb(240, 240, 240)">
                                    <InstructionStep>Passo 1</InstructionStep>
                                    <InstructionItemContent>
                                        Coloca o número da inscrição ( <b style={{ color: "red", marginBottom: "30px" }}>{id}</b> ) na descrição do PIX.
                                    </InstructionItemContent>
                                </InstructionItem>

                                {/* <InstructionItem color="#e3f2fd"> */}
                                <InstructionItem color="rgb(230, 230, 230)">
                                    <InstructionStep>Passo 2</InstructionStep>
                                    <InstructionItemContent>
                                        Efetuar o pagamento através do PIX para:
                                        <ul style={{ listStyle: "none" }}>
                                            <br />
                                            <li>Banco Caixa Econômica</li>
                                            <li>Chave PIX CPF</li>
                                            <li><b>Pix: 691.807.841-00 </b></li>
                                            <li>José Carlos Lima Lopes</li>
                                        </ul>
                                    </InstructionItemContent>
                                </InstructionItem>

                                <InstructionItem color="rgb(220, 220, 220)">
                                    {/* <InstructionItem color="#ffecb3"> */}
                                    <InstructionStep>Passo 3</InstructionStep>
                                    <InstructionItemContent>
                                        Enviar o comprovante de pagamento (com número da inscrição descrição)  para:
                                        <ul style={{ listStyle: "none" }}>
                                            <li>
                                                <br />
                                                <StyledLink
                                                    target="_blank"
                                                    href={`https://whatsa.me/5593991311576/?t=Ol%C3%A1+José+Carlos+Lima+Lopes%2C+estou+enviando+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+no+%2AVI+REI+DA+PRAIA+NO+GI+2024%2A%0A%0A%2AInscri%C3%A7%C3%A3o+N%C2%B0+${id}`}
                                                    >
                                                    (93) 99131-1576 <FaWhatsapp />
                                                </StyledLink>
                                            </li>
                                        </ul>
                                    </InstructionItemContent>
                                </InstructionItem>

                                <InstructionItem color="rgb(210, 210, 210)">
                                    {/* <InstructionItem color="#c8e6c9"> */}
                                    <InstructionStep>Passo 4</InstructionStep>
                                    <InstructionItemContent>
                                        Acompanhe o status do pagamento em:
                                        <br />
                                        <ul style={{ listStyle: "none" }}>
                                            <li>
                                                <HighlightedLink href="/profile/subscription">Minhas Inscrições</HighlightedLink>
                                            </li>
                                        </ul>
                                    </InstructionItemContent>
                                </InstructionItem>
                            </InstructionList>
                        </PaymentContainer>
                    </Content>
                </Container>
            )
        default:
            return <h1>Pagamento não liberado para esse torneio</h1>
    }
}
export default  PaymentEnrollmentViReiDaPraiaDeJiuJitsuNoGi
